import { render, staticRenderFns } from "./OptInput.vue?vue&type=template&id=5bbb48fa&"
import script from "./OptInput.vue?vue&type=script&lang=js&"
export * from "./OptInput.vue?vue&type=script&lang=js&"
import style0 from "./OptInput.vue?vue&type=style&index=0&id=5bbb48fa&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
